import { render, staticRenderFns } from "./TiWen.vue?vue&type=template&id=22c579dc&scoped=true&"
import script from "./TiWen.vue?vue&type=script&lang=js&"
export * from "./TiWen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c579dc",
  null
  
)

export default component.exports